import React from 'react';
import { useTranslation } from 'react-i18next';
import './PaymentGatewaySelector.css';

interface PaymentGatewaySelectorProps {
    selectedGateway: 'razorpay' | 'paypal';
    onSelectGateway: (gateway: 'razorpay' | 'paypal') => void;
    amount: number;
}

const PaymentGatewaySelector: React.FC<PaymentGatewaySelectorProps> = ({
    selectedGateway,
    onSelectGateway,
}) => {
    const { t } = useTranslation();

    return (
        <div className="payment-gateway-selector">
            <label className="gateway-label">
                {t('donationForm.selectPaymentGateway')}
                <span className="required-asterisk">*</span>
            </label>

            <div className="gateway-options">
                {/* Razorpay Option */}
                <button
                    type="button"
                    className={`gateway-option ${selectedGateway === 'razorpay' ? 'active' : ''}`}
                    onClick={() => onSelectGateway('razorpay')}
                >
                    <div className="gateway-icon">
                        <img
                            src="/images/payment/razorpay_anonymous.png"
                            alt="Razorpay"
                        />
                    </div>
                    <div className="gateway-content">
                        <div className="gateway-description">{t('donationForm.razorpayDescription')}</div>
                    </div>
                </button>

                {/* PayPal Option */}
                <button
                    type="button"
                    className={`gateway-option ${selectedGateway === 'paypal' ? 'active' : ''}`}
                    onClick={() => onSelectGateway('paypal')}
                >
                    <div className="gateway-icon">
                        <img
                            src="/images/payment/paypal_anonymous.svg"
                            alt="PayPal"
                        />
                    </div>
                    <div className="gateway-content">
                        <div className="gateway-description">{t('donationForm.paypalDescription')}</div>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default PaymentGatewaySelector;
